import { forwardRef, useContext } from "react";

import headingLevelContext from "./headingLevelContext";

export default forwardRef(function H({ adjustLevel = 0, ...props }, ref) {
  let level = Math.min(6, useContext(headingLevelContext) + adjustLevel);
  let Element = `h${level}`;
  return <Element ref={ref} {...props} />;
});
